/**
 * 模块名称: 绩效管理模块
 * @author yangzhihang@372163.com
 */

import React from 'react'
import { Switch, Route } from 'react-router-dom'
import AchReault from './AchResult'
import YearTarget from './YearTarget'
import AchAudit from './AchAudit'
import ProbationAchAudit from './ProbationAchAudit'
import Operations from './Operations'
import Profit from './Profit'
import './assets/style.scss'

const Index = ({ match, history }) => {
  return (
    <div>
      <Switch>
        <Route path={match.path + '/achresult'} exact component={AchReault} />
        <Route path={match.path + '/yeartarget'} exact component={YearTarget} />
        <Route path={match.path + '/achaudit'} component={AchAudit} />
        <Route path={match.path + '/probationachaudit'} component={ProbationAchAudit} />
        <Route path={match.path + '/operations'} exact component={Operations} />
        <Route path={match.path + '/profit'} component={Profit} />
        <Route component={AchReault} />
      </Switch>
    </div>
  )
}

export default Index